export const NYL_VERIFICATION_LINK_KEY = 'NYL_VERIFICATION_LINK';

export const setVerificationLink = (link) => {
  if (!link) {
    return;
  }
  try {
    sessionStorage.setItem(NYL_VERIFICATION_LINK_KEY, link);
  } catch (e) {
    // sessionStorage unavailable
  }
};

export const getVerificationLink = () => {
  try {
    return sessionStorage.getItem(NYL_VERIFICATION_LINK_KEY) || null;
  } catch (e) {
    return null;
  }
};

export const clearVerificationLink = () => {
  try {
    sessionStorage.removeItem(NYL_VERIFICATION_LINK_KEY);
  } catch (e) {
    // sessionStorage unavailable
  }
};
